export function pascalToCamelCaseRecursive(input: unknown): unknown {
    if (Array.isArray(input)) {
        return input.map(pascalToCamelCaseRecursive);
    }

    if (input !== null && typeof input === 'object') {
        const obj = input as Record<string, unknown>;
        const result: Record<string, unknown> = {};

        for (const [key, value] of Object.entries(obj)) {
            const newKey = pascalToCamelKey(key);
            result[newKey] = pascalToCamelCaseRecursive(value);
        }

        return result;
    }

    return input;
}

function pascalToCamelKey(key: string): string {
    return key.charAt(0).toLowerCase() + key.slice(1);
}
